import { render } from "./ApplicationForm.vue?vue&type=template&id=5cdfba5d&scoped=true"
import script from "./ApplicationForm.vue?vue&type=script&lang=js"
export * from "./ApplicationForm.vue?vue&type=script&lang=js"

import "./ApplicationForm.vue?vue&type=style&index=0&id=5cdfba5d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdfba5d"]])

export default __exports__